import { FollowNotificationFrequency } from "../types/follow"

export function parseFollowNotificationFrequency(
    setting: string,
): FollowNotificationFrequency {
    switch (setting) {
        case FollowNotificationFrequency.ALL:
            return FollowNotificationFrequency.ALL
        case FollowNotificationFrequency.NONE:
            return FollowNotificationFrequency.NONE
        default:
            return FollowNotificationFrequency.SMART
    }
}
